import { motion, useReducedMotion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 26, className, as = "div", ...rest }) => {
  const reduce = useReducedMotion();
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y: reduce ? 0 : y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-70px" }}
      transition={{ duration: 0.75, delay, ease }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};

export const Label = ({ children, className = "" }) => (
  <span className={`inline-block font-mono text-[11px] uppercase tracking-[0.24em] text-[#4A6B5D] ${className}`}>
    {children}
  </span>
);
